import type { Metric } from '@/shared/generated'

export type { BIRequest, BIResponse, BIAIRequest } from '@/shared/generated'

export enum DateAggregation {
	DateKey = 'date_key',
	WeekKey = 'week_key',
	MonthKey = 'month_key',
}

export type MetricOption = {
	label: Metric['name']
	value: Metric['name']
	type: Metric['type']
	color: string
}

export type DynamicAnalyticsData = {
	accepted: number
	accepted_percent: number
	assortment: number
	average_cost: number
	average_discount_percent: number
	average_price: number
	average_price_change: number
	average_selling_price: number
	average_shelf_price: number
	changed_manually: number
	changed_manually_percent: number
	gross_profit: number
	gross_profit_margin: number
	locked: number
	locked_percent: number
	not_accepted: number
	not_accepted_percent: number
	period_beginning: string
	revenue: number
	revenue_period: number
	sales_items: number
	stock_quantity: number
	unassigned: number
	unassigned_percent: number
	week_key: string
}
